import React from 'react'
import PropTypes from 'propTypes'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import baseUrl from '../../config/baseUrl'

import { useFetchInitialState } from './useFetchInitialState'

import * as initialStateModule from '../../reducks/initialState'

import SkeletonToolbar from '@/core/skeletons/SkeletonToolbar'
import ErrorScene from '../../scenes/ErrorScene'

const PopulateInitialState = ({ children, setInitialReduxState, companyId, staticData, searchParams }) => {
  const {
    status: stateFetchStatus,
    error,
    data: initialState = {},
    refetch: refetchInitialState,
  } = useFetchInitialState({
    companyId,
    searchParams,
    setInitialReduxState,
  })
  if (stateFetchStatus === 'error') {
    if (error && error.response && error.response.status === 401) {
      window.location.replace(`${baseUrl()}/users/js_redirect?url=${encodeURIComponent(window.location.href)}`)
      return <SkeletonToolbar />
    }

    return <ErrorScene />
  }

  // check if the initial state is populated in the Redux state to avoid errors where loading is finished but Redux state is not yet set
  const isReduxStorePopulated = !isEmpty(staticData)
  if (stateFetchStatus === 'loading' || !isReduxStorePopulated) return <SkeletonToolbar />

  return children({ initialState, refetchInitialState })
}

const { func, string, shape } = PropTypes
PopulateInitialState.propTypes = {
  children: func,
  setInitialReduxState: func,
  companyId: string,
  staticData: shape({}),
  searchParams: string,
}

const mapStateToProps = state => ({
  staticData: state.static_data,
})

const mapDispatchToProps = dispatch => ({
  setInitialReduxState: state => {
    dispatch(initialStateModule.initialiseStaticData(state.static_data))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(PopulateInitialState)
